/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  CreateAPIKeyForIntegratorUserOptions,
  CreateAPIKeyForIntegratorUserStatus201,
  CreateAPIKeyForIntegratorUserStatus404,
  CreateAPIKeyForIntegratorUserStatus500,
} from '../types/CreateAPIKeyForIntegratorUser'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { createAPIKeyForIntegratorUser } from '../clients/createAPIKeyForIntegratorUser'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const createAPIKeyForIntegratorUserMutationKey = () =>
  [{ url: '/v1/user/:user_id/apikey' }] as const

export function createAPIKeyForIntegratorUserMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = createAPIKeyForIntegratorUserMutationKey()
  return mutationOptions<
    CreateAPIKeyForIntegratorUserStatus201,
    ResponseErrorConfig<
      CreateAPIKeyForIntegratorUserStatus404 | CreateAPIKeyForIntegratorUserStatus500
    >,
    CreateAPIKeyForIntegratorUserOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return createAPIKeyForIntegratorUser({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Create apikey for a user
 * {@link /v1/user/:user_id/apikey}
 */
export function useCreateAPIKeyForIntegratorUser<TContext>(
  options: {
    mutation?: UseMutationOptions<
      CreateAPIKeyForIntegratorUserStatus201,
      ResponseErrorConfig<
        CreateAPIKeyForIntegratorUserStatus404 | CreateAPIKeyForIntegratorUserStatus500
      >,
      CreateAPIKeyForIntegratorUserOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? createAPIKeyForIntegratorUserMutationKey()

  const baseOptions = createAPIKeyForIntegratorUserMutationOptions(config) as UseMutationOptions<
    CreateAPIKeyForIntegratorUserStatus201,
    ResponseErrorConfig<
      CreateAPIKeyForIntegratorUserStatus404 | CreateAPIKeyForIntegratorUserStatus500
    >,
    CreateAPIKeyForIntegratorUserOptions,
    TContext
  >

  return useMutation<
    CreateAPIKeyForIntegratorUserStatus201,
    ResponseErrorConfig<
      CreateAPIKeyForIntegratorUserStatus404 | CreateAPIKeyForIntegratorUserStatus500
    >,
    CreateAPIKeyForIntegratorUserOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    CreateAPIKeyForIntegratorUserStatus201,
    ResponseErrorConfig<
      CreateAPIKeyForIntegratorUserStatus404 | CreateAPIKeyForIntegratorUserStatus500
    >,
    CreateAPIKeyForIntegratorUserOptions,
    TContext
  >
}
